import { VStack, Text } from "@chakra-ui/react";

const InfoField = ({ label, children }) => (
    <VStack align="flex-start" gap={1}>
        <Text color="gray.500" fontSize="xs" fontWeight={600} textTransform="uppercase" letterSpacing="wider">
            {label}
        </Text>
        {children}
    </VStack>
);

export default InfoField;
